export default "__VITE_ASSET__21ucquCc__"